var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06264 10.3856L6.76489 14.5736C7.19089 14.5736 7.37539 14.3906 7.59664 14.1708L9.59389 12.2621L13.7324 15.2928C14.4914 15.7158 15.0261 15.4931 15.2309 14.5946L17.9474 1.86557L17.9481 1.86482C18.1889 0.742816 17.5424 0.304066 16.8029 0.579316L0.835389 6.69257C-0.254361 7.11557 -0.237861 7.72307 0.650139 7.99832L4.73239 9.26807L14.2146 3.33482C14.6609 3.03932 15.0666 3.20282 14.7329 3.49832L7.06264 10.3856Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.4b9e03ef0da85cda935b60ca36ae08c3.svg";
export { ForwardRef as ReactComponent };